const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Dpto',
        label: 'Cod. Dpto.',
        minWidth: 100
    },
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },
    {
        prop: 'Municipio_Nombre',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'Direccion',
        label: 'Dirección',
        minWidth: 150
    },
    {
        prop: 'Barrio',
        label: 'Barrio',
        minWidth: 150
    },
    {
        prop: 'Coordenadas',
        label: 'Coordenadas',
        minWidth: 150
    },
    {
        prop: 'Estado',
        label: 'Estado',
        minWidth: 150
    },
    {
        prop: 'ItemCode',
        label: 'Código',
        minWidth: 100
    },
    {
        prop: 'ItemName',
        label: 'Elemento',
        minWidth: 200
    },
    {
        prop: 'Cantidad',
        label: 'Cantidad',
        minWidth: 100
    },
    {
        prop: 'stock',
        label: 'Stock',
        minWidth: 100
    },
    {
        prop: 'MedidaV',
        label: 'Unidad',
        minWidth: 100
    },
    {
        prop: 'FuenteFinanciación',
        label: 'Fuente Financiación',
        minWidth: 150
    },
    {
        prop: 'Fabricante',
        label: 'Fabricante',
        minWidth: 150
    },
    {
        prop: 'Modelo',
        label: 'Modelo',
        minWidth: 150
    },
    {
        prop: 'Serial',
        label: 'Serial',
        minWidth: 150
    },
    {
        prop: 'MAC',
        label: 'MAC',
        minWidth: 150
    }
]

export default table
